export function calculateDecision(
  context,
  risk,
  prediction,
  adaptive,
  swarm,
  memoryMatches
) {
  const reasons = [];

  // ?? CRITICAL CONDITIONS
  if (risk.level === "CRITICAL") {
    reasons.push("High risk level detected");
  }

  if (context.voc > 220) {
    reasons.push("Air quality anomaly (VOC high)");
  }

  if (context.pm25 > 100) {
    reasons.push("Air quality anomaly (PM2.5 high)");
  }

  if (prediction?.earlyWarning) {
    reasons.push("Escalation predicted");
  }

  // ===== DECISION LOGIC =====
  if (risk.level === "CRITICAL") {
  return {
    priority: "HIGH",
    action: "notifySecurity",
    explanation: ["Critical environmental threat detected"],
  };
}

  if (risk.level === "WARNING") {
    return {
      priority: "HIGH",
      action: "increaseMonitoring",
      explanation: reasons,
    };
  }

  if (risk.level === "ELEVATED") {
    return {
      priority: "MEDIUM",
      action: "monitorClosely",
      explanation: reasons,
    };
  }

  return {
    priority: "NORMAL",
    action: "continueMonitoring",
    explanation: ["No abnormal indicators"],
  };
}